import {
  useCompositeSeparator
} from "../__chunks/RY6ZOIHR.js";
import "../__chunks/D3IXN5NP.js";
import "../__chunks/WJ37OVG2.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/NQJBHION.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import "../__chunks/PNRLI7OV.js";

// src/select/select-separator.ts
var useSelectSeparator = createHook(
  (props) => {
    props = useCompositeSeparator(props);
    return props;
  }
);
var SelectSeparator = createComponent(
  (props) => {
    const htmlProps = useSelectSeparator(props);
    return createElement("hr", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  SelectSeparator.displayName = "SelectSeparator";
}
export {
  SelectSeparator,
  useSelectSeparator
};
